export function resolveOverriddenValue<T>(
  defaultValue: T | null | undefined,
  customValue: T | null | undefined,
  format: (value: T) => string,
): { struckThrough: string | null; display: string } {
  const isSet = (value: T | null | undefined): value is T => value !== undefined && value !== null;

  if (isSet(customValue) && customValue !== defaultValue) {
    return {
      struckThrough: isSet(defaultValue) ? format(defaultValue) : null,
      display: format(customValue),
    };
  }

  if (isSet(defaultValue)) {
    return { struckThrough: null, display: format(defaultValue) };
  }

  if (isSet(customValue)) {
    return { struckThrough: null, display: format(customValue) };
  }

  return { struckThrough: null, display: '-' };
}

export function formatPercentOption(
  value: number,
  options?: { value: number; label: string }[] | null,
): string {
  return options?.find((option) => option.value === value)?.label ?? `${value}%`;
}
